/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".train-breacrumbs[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;align-items:center;gap:4px}.train-icon[_ngcontent-%COMP%]{height:10px}.train-name[_ngcontent-%COMP%]{font-weight:500}"];
export { styles as styles };
